import { colorsEK } from '../../../constants/colors';

export const useStyles = ({ color }: { color: string }) => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: 1,
    },
    buttonsContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'end',
      columnGap: 1,
    },
    button: {
      color: colorsEK.white,
      background: color,
      fontSize: 14,
      fontWeight: 500,
      lineHeight: 1,
      paddingY: 1,
      paddingX: 3,
      textTransform: 'none',
      borderRadius: 99,

      '&:hover': {
        backgroundColor: color,
        color: colorsEK.white,
      },
    },
  };
};
